import { z } from "zod";

const envSchema = z.object({
	VITE_SERVER_URL: z.url(),
	VITE_WEB_URL: z.url(),
});

export const env = envSchema.parse({
	VITE_SERVER_URL: import.meta.env.VITE_SERVER_URL,
	VITE_WEB_URL: import.meta.env.VITE_WEB_URL,
});
